import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NotificationService, UserAuth } from '@nrwl/common-lib';
import { TemplateService } from '../../template.service';
import { BaseSetupService } from '../../base-setup.service';

@Component({
  selector: 'nrwl-save-template',
  templateUrl: './save-template.component.html',
  styleUrls: ['./save-template.component.scss']
})
export class SaveTemplateComponent implements OnInit, OnDestroy {
  @ViewChild('saveTemplate', { static: true }) form: NgForm;
  isLoading: boolean;
  loaderMessage = 'Template creating...';
  title = 'Save template';
  formData = {
    templateName: '',
    shareTemplate: false
  };
  actualTemplateName: string;
  isNameChanged = true;
  hasReadWriteRole: boolean;
  private readonly unsubscribe: Subject<void> = new Subject();
  constructor(
    private readonly notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: object,
    private templateService: TemplateService,
    private readonly userAuth: UserAuth,
    public dialogRef: MatDialogRef<SaveTemplateComponent>,
    private readonly baseService: BaseSetupService
  ) {
    this.hasReadWriteRole = this.userAuth.isAuthedFor('READ_WRITE');
  }
  //eslint-disable-next-line
  ngOnInit(): void {
    this.title = 'Save template';
    this.loaderMessage = 'Loading template...';
    if (this.templateService.getTemplateId()) {
      this.getTestTemplate();
    }
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  onChangeName(name: string): void {
    if (this.actualTemplateName === name) {
      this.isNameChanged = true;
    } else {
      this.isNameChanged = false;
    }
  }
  getTestTemplate(): void {
    this.isLoading = true;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.templateService
      ._getTestTemplate(this.templateService.getTemplateId())
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        this.isLoading = false;
        this.actualTemplateName = res.data['name'];
        this.formData.templateName = this.actualTemplateName;
        this.formData.shareTemplate = res.data['accessLevel'] === 'private' ? false : true;
      });
  }
  saveTemplateConfig(): void {
    this.loaderMessage = 'Creating template...';
    this.isLoading = true;
    const templateConfig = {
      testType: this.data['testType'],
      name: this.formData.templateName,
      template: this.data['deviceInfo']
    };
    if (this.formData.shareTemplate) {
      templateConfig['accessLevel'] = 'shared';
    }
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.templateService
      ._saveTemplate(templateConfig)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        res => {
          this.baseService.templateNameEvent.next(this.formData.templateName);
          this.isLoading = false;
          this.templateService.setTemplateId(res.data.id);
          this.dialogRef.close();
          this.notificationService.onSuccess(res.data.message);
        },
        err => {
          this.isLoading = false;
          this.notificationService.onFail(err?.error?.data?.message);
        }
      );
  }
  updateTemplateConfig(): void {
    this.loaderMessage = 'Updating template...';
    this.isLoading = true;
    const templateConfig = {
      id: this.templateService.getTemplateId(),
      data: {
        testType: this.data['testType'],
        name: this.formData.templateName,
        template: this.data['deviceInfo']
      }
    };
    if (this.formData.shareTemplate) {
      templateConfig.data['accessLevel'] = 'shared';
    }
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.templateService
      ._updateTemplate(templateConfig)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        res => {
          this.baseService.templateNameEvent.next(this.formData.templateName);
          this.isLoading = false;
          this.dialogRef.close();
          this.notificationService.onSuccess(res.data.message);
        },
        err => {
          this.isLoading = false;
          this.notificationService.onFail(err?.error?.data?.message);
        }
      );
  }
}
